import { render, staticRenderFns } from "./AnswerSheet.vue?vue&type=template&id=6af90c3e&scoped=true&"
import script from "./AnswerSheet.vue?vue&type=script&lang=js&"
export * from "./AnswerSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af90c3e",
  null
  
)

export default component.exports